/* Nail Color Consultation — theme build.
   Generated by scripts/build_theme_compact.py from design/studio.template.html. */
(function(){
  var root=document.querySelector('.ncc-consultation');
  if(!root) return;
  var urls=JSON.parse(root.dataset.nccAssets);
  /* Two-stage plate load — hand edit 2026-10-27, not yet in build_theme_compact.py.
     The full plate set is 2.1MB gzipped and every hand waited on it, so on a phone the
     six tone tiles sat blank for seconds. The six tone|natural|medium plates the page
     opens on now ship in ncc-plates-hero.json (~0.2MB); the full set follows and merges
     in. Anything asking for a plate not yet loaded awaits PLATES_FULL. */
  var PLATES_FULL=Promise.resolve();
  Promise.all([fetch(urls.hero||urls.plates).then(function(r){return r.json();}),
               fetch(urls.shades).then(function(r){return r.json();})])
    .then(function(res){
      var P=res[0];
      if(urls.hero) PLATES_FULL=fetch(urls.plates).then(function(r){return r.json();})
        .then(function(f){ Object.assign(P.plates, f.plates); })
        .catch(function(e){ if(window.console) console.error('NCC full plates failed', e); });
      start(P, res[1], root);
    })
    .catch(function(e){
      root.innerHTML='<p style="padding:32px">The colour studio could not load. Please refresh.</p>';
      if(window.console) console.error('NCC assets failed', e);
    });
  function start(PLATES, CATALOG, root){
    const TONES=[
     {key:"porcelain",label:"Porcelain",chip:"#F1C3B5"},{key:"fair",label:"Fair",chip:"#DDA185"},
     {key:"honey",label:"Honey",chip:"#BD744D"},{key:"tan",label:"Tan",chip:"#96543D"},
     {key:"deep",label:"Deep",chip:"#693F35"},{key:"espresso",label:"Espresso",chip:"#452D29"}];
    const SHAPES=[
     {key:"natural",label:"Natural",d:"M12 76C10 60 10 37 12 21C14 10 21 5 28 5s14 5 16 16c2 16 2 39 0 55-8 4-24 4-32 0Z"},
     {key:"almond",label:"Almond",d:"M12 76C10 55 11 32 17 17 20 10 24 5 28 2c4 3 8 8 11 15 6 15 7 38 5 59-8 4-24 4-32 0Z"},
     {key:"stiletto",label:"Stiletto",d:"M12 76C11 56 13 34 19 18L28 1l9 17c6 16 8 38 7 58-8 4-24 4-32 0Z"}];
    const LENGTHS=[{key:"short",label:"Short"},{key:"medium",label:"Medium"},{key:"long",label:"Long"}];

    /* Open on a shade the try-on can actually demonstrate. Sorted by family, the
       first entry happens to be a crackle, which renders as a flat product swatch
       and makes the tool look broken on arrival. Pick a mid-toned recolourable
       creme instead, falling back safely if the catalogue changes. */
    const firstDemo = CATALOG.find(s=>s.render_mode==="recolor" && s.family==="red"
                                      && s.available && /^#[89AB]/i.test(s.hex))
                   || CATALOG.find(s=>s.render_mode==="recolor" && s.available)
                   || CATALOG[0];
    /* A colour-family landing page pre-filters the bar to its family.
       Shopify collections cannot do this: colour lives on the variant and a
       collection holds products, so every family collection would contain the
       same five products. Deriving the filter from the page handle gives each
       family a real URL with its own copy and its own set of shades. */
    /* Published handle -> internal family, the same trick TONE_SLUGS plays below.
       The catalogue calls the greys "neutral"; nobody searches that, so the page
       ships as /pages/grey-nail-polish. Without this alias the handle regex yields
       "grey", CATALOG.some() finds no such family, startFamily silently falls back
       to "all", and the page opens showing every shade while its own copy says
       "All 46 greys". Keep this in step with HANDLE in build_landing_pages.py. */
    const FAMILY_SLUGS={grey:"neutral"};
    const FAMILY_FROM_PATH=(()=>{
      const m=location.pathname.match(/\/pages\/([a-z]+)-nail-polish\b/);
      return m ? (FAMILY_SLUGS[m[1]] || m[1]) : null;
    })();

    /* Skin-tone landing pages. The handles use the words people actually search
       ("dark skin", "pale skin", "olive skin") rather than our internal tone
       names, so the slug carries the query and the tool opens on the right hand. */
    const TONE_SLUGS={pale:"porcelain",fair:"fair",olive:"honey",
                      tan:"tan",brown:"deep",dark:"espresso"};
    const TONE_FROM_PATH=(()=>{
      /* Two shapes carry a tone: the tone guide itself, and the family x tone
         pages (/pages/red-nail-polish-for-dark-skin), which are the only URLs
         that can answer "red on deep skin" — a Shopify collection cannot, since
         colour lives on the variant and all nine families sit inside the same
         six products. The family regex above already matches their prefix, so
         one extra pattern here opens the right hand as well as the right bar. */
      const m=location.pathname.match(/\/pages\/(?:nail-colors|[a-z]+-nail-polish)-for-([a-z]+)-skin\b/);
      return m && TONE_SLUGS[m[1]] ? TONE_SLUGS[m[1]] : null;
    })();
    const startFamily = FAMILY_FROM_PATH && CATALOG.some(s=>s.family===FAMILY_FROM_PATH)
      ? FAMILY_FROM_PATH : "all";
    const startShade = startFamily==="all" ? firstDemo
      : (CATALOG.find(s=>s.family===startFamily && s.render_mode==="recolor" && s.available)
         || CATALOG.find(s=>s.family===startFamily) || firstDemo);
    const state={tone:TONE_FROM_PATH||"tan",shape:"natural",length:"medium",
                 shade:startShade,family:startFamily};
    const $=id=>root.querySelector('#'+id);
    const plateKey=()=>`${state.tone}|${state.shape}|${state.length}`;

    /* ---------- colour maths (mirrors scripts/generate-v15.py) ---------- */
    function srgbToLin(v){v/=255;return v<=0.04045?v/12.92:Math.pow((v+0.055)/1.055,2.4)}
    function linToSrgb(v){v=Math.min(1,Math.max(0,v));return (v<=0.0031308?v*12.92:1.055*Math.pow(v,1/2.4)-0.055)*255}
    const E=216/24389,K=24389/27;
    const fwd=t=>t>E?Math.cbrt(t):(K*t+16)/116;
    function rgb2lab(r,g,b){
      r=srgbToLin(r);g=srgbToLin(g);b=srgbToLin(b);
      let x=(r*.4124564+g*.3575761+b*.1804375)/.95047,
          y=(r*.2126729+g*.7151522+b*.0721750),
          z=(r*.0193339+g*.1191920+b*.9503041)/1.08883;
      const fx=fwd(x),fy=fwd(y),fz=fwd(z);
      return [116*fy-16,500*(fx-fy),200*(fy-fz)];
    }
    function lab2rgb(L,a,bb){
      const fy=(L+16)/116,fx=fy+a/500,fz=fy-bb/200;
      const inv=t=>{const c=t*t*t;return c>E?c:(116*t-16)/K};
      const x=inv(fx)*.95047, y=L>K*E?Math.pow((L+16)/116,3):L/K, z=inv(fz)*1.08883;
      return [linToSrgb(x*3.2404542+y*-1.5371385+z*-0.4985314),
              linToSrgb(x*-0.9692660+y*1.8760108+z*0.0415560),
              linToSrgb(x*0.0556434+y*-0.2040259+z*1.0572252)];
    }
    const hex2rgb=h=>[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];

    /* ---------- runtime recolor ---------- */
    const imgCache=new Map();
    function loadImg(src){
      if(imgCache.has(src))return imgCache.get(src);
      const p=new Promise(res=>{const i=new Image();i.onload=()=>res(i);i.src=src});
      imgCache.set(src,p);return p;
    }

    let renderToken=0;
    async function render(){
      const token=++renderToken;
      let plate=PLATES.plates[plateKey()];
      const shade=state.shade;
      const cv=$("canvas"),shot=$("photoshot"),notice=$("notice");

      if(shade.render_mode==="photo"){
        // A glitter, crackle or metallic finish has particle or pattern geometry
        // the base photograph does not contain. Recoloring it would invent a
        // texture that is not the product, so the real swatch is shown instead.
        shot.src=shade.swatch_url; shot.alt=`${shade.code} ${shade.finish} swatch`;
        shot.classList.remove("hidden"); cv.classList.add("hidden");
        notice.textContent=`${shade.finish[0].toUpperCase()+shade.finish.slice(1)} finish — shown as the product swatch. This texture can't be previewed on the hand yet.`;
        notice.classList.remove("hidden");
        return;
      }
      shot.classList.add("hidden"); cv.classList.remove("hidden"); notice.classList.add("hidden");

      if(!plate){ await PLATES_FULL; plate=PLATES.plates[plateKey()]; if(token!==renderToken||!plate)return; }
      const [base,mask]=await Promise.all([loadImg(plate.src),loadImg(plate.mask)]);
      if(token!==renderToken)return;

      // Match the canvas to the plate's own pixels. The element was fixed at
      // 1000x625, which quietly downsampled the full-resolution plates and threw
      // away exactly the sharpness the photography has. CSS still scales it to fit.
      if(cv.width!==base.naturalWidth||cv.height!==base.naturalHeight){
        cv.width=base.naturalWidth; cv.height=base.naturalHeight;
      }

      /* The stage must wear the same ground as the plate inside it. Since the
         grounds are graded per tone, a stage left on the page cream would show a
         rectangle around every hand — the exact seam this project has paid for
         twice. plates.json is the single source of the value. */
      const stageEl=document.querySelector(".ncc-consultation .stage");
      if(stageEl)stageEl.style.setProperty("--plate-ground",plate.ground||"#E6DED4");

      const ctx=cv.getContext("2d",{willReadFrequently:true});
      ctx.drawImage(base,0,0,cv.width,cv.height);
      const img=ctx.getImageData(0,0,cv.width,cv.height);

      const mc=document.createElement("canvas");mc.width=cv.width;mc.height=cv.height;
      const mctx=mc.getContext("2d",{willReadFrequently:true});
      mctx.drawImage(mask,0,0,cv.width,cv.height);
      const md=mctx.getImageData(0,0,cv.width,cv.height).data;

      const [s05,s50,s92,s95,s998]=plate.srcL;
      const sLo=Math.max(s50-s05,1), sHi=Math.max(s95-s50,1);
      // A particle shade recolours to its MEASURED BASE -- the polish under the
      // flake -- and the flake itself is composited after this loop.
      const [tr,tg,tb]=hex2rgb(shade.render_mode==="particle"
        ? (shade.base_hex||shade.hex) : shade.hex);
      const [tL,tA,tB]=rgb2lab(tr,tg,tb);
      // Body/highlight/shadow spread comes from the gloss profile measured on real
      // photographed lacquer, so an arbitrary catalogue hex still reads as polish
      // rather than as a flat fill.
      const dLo=Math.max(tL*(1-PLATES.gloss.drop),2), dHi=Math.min(tL*(1+PLATES.gloss.lift),100);
      const dropSpan=Math.max(tL-dLo,1), liftSpan=Math.max(dHi-tL,1);

      const d=img.data;
      for(let i=0;i<d.length;i+=4){
        const m=md[i]/255;
        if(m<=0.004)continue;
        const [L,,]=rgb2lab(d[i],d[i+1],d[i+2]);
        const rel=L-s50;
        let outL = rel<0 ? tL+rel*(dropSpan/sLo) : tL+rel*(liftSpan/sHi);
        const spec=Math.pow(Math.min(1,Math.max(0,(L-s92)/Math.max(s998-s92,1))),1.6);
        outL += spec*Math.max(dHi-tL,0)*0.55;
        const damp=1-spec*0.72;
        const [nr,ng,nb]=lab2rgb(Math.min(100,Math.max(0,outL)),tA*damp,tB*damp);
        d[i]  =d[i]  *(1-m)+nr*m;
        d[i+1]=d[i+1]*(1-m)+ng*m;
        d[i+2]=d[i+2]*(1-m)+nb*m;
      }
      if(shade.render_mode==="particle")
        addParticles(d,md,cv.width,cv.height,shade,
                     `${state.tone}|${state.shape}|${state.length}`);
      ctx.putImageData(img,0,0);
    }

    /* ---------- UI ---------- */
    /* A descriptive name derived from the measured colour.
       Deliberately descriptive, never invented marketing names: the supplier codes
       (RC39, BP06) mean nothing to a shopper, but making up brand names would put
       words on a checkout page that the product data does not support. */
    function shadeName(s){
      /* scripts/name_shades.py writes the same string onto every shade and sends it
         to Shopify as the variant's option value, so the name on the hand, the name
         in the cart and the name at checkout are one string. The derivation below
         stays as the fallback for a catalogue built before that ran. */
      if(s.name) return s.name;
      const [r,g,b]=hex2rgb(s.hex);
      const [L,,]=rgb2lab(r,g,b);
      const mx=Math.max(r,g,b),mn=Math.min(r,g,b);
      const sat=mx===0?0:(mx-mn)/mx;
      const depth = L<25?"Espresso" : L<40?"Deep" : L<58?"Rich" : L<74?"Soft" : "Pale";
      const HUE={red:"red",pink:"pink",plum:"plum",purple:"violet",blue:"blue",
                 green:"green",yellow:"citrine",orange:"coral",nude:"nude",
                 neutral:"grey",black:"black"};
      const hue = sat<0.10 ? (L>70?"ivory":L<25?"noir":"grey") : (HUE[s.family]||s.family);
      const FIN={creme:"crème",sheer:"sheer",glitter:"glitter",shimmer:"shimmer",
                 metallic:"metallic",crackle:"crackle"};
      return `${depth} ${hue} ${FIN[s.finish]||s.finish}`;
    }
    function buildTones(){
      $("tones").innerHTML=TONES.map(t=>`<button type="button" data-k="${t.key}" aria-pressed="${state.tone===t.key}">
        <span class="chip" style="--tone:${t.chip}"></span><span class="label">${t.label}</span></button>`).join("");
      $("tones").querySelectorAll("button").forEach(b=>b.onclick=()=>{state.tone=b.dataset.k;sync();});
    }
    function buildSeg(host,items,field,icon){
      $(host).innerHTML=items.map(i=>`<span class="opt">
        <input type="radio" name="${field}" id="${field}-${i.key}" value="${i.key}" ${state[field]===i.key?"checked":""}>
        <label for="${field}-${i.key}">${icon?`<svg viewBox="0 0 56 82" aria-hidden="true"><path d="${i.d}"/></svg>`:""}<span>${i.label}</span></label></span>`).join("");
      $(host).querySelectorAll("input").forEach(inp=>inp.onchange=()=>{state[field]=inp.value;sync();});
    }
    function families(){
      const c={};CATALOG.forEach(s=>c[s.family]=(c[s.family]||0)+1);
      return ["all",...Object.keys(c).sort((a,b)=>c[b]-c[a])];
    }
    /* The chip shows the word the shopper reads everywhere else. The internal key
       stays "neutral" so visible() and state.family are untouched -- this is the
       label only, and it matches both /pages/grey-nail-polish and the shade names
       name_shades.py writes ("Rich grey creme"). */
    const FAMILY_CHIP={neutral:"grey"};
    function buildFilters(){
      $("filters").innerHTML=families().map(f=>
        `<button type="button" data-f="${f}" aria-pressed="${state.family===f}">${FAMILY_CHIP[f]||f}</button>`).join("");
      $("filters").querySelectorAll("button").forEach(b=>b.onclick=()=>{state.family=b.dataset.f;buildBar();buildFilters();});
    }
    function visible(){return state.family==="all"?CATALOG:CATALOG.filter(s=>s.family===state.family)}
    function buildBar(){
      const list=visible();
      $("bar").innerHTML=list.map(s=>`<button type="button" data-slug="${s.slug}" aria-pressed="${s.slug===state.shade.slug}"
          title="${s.code} · ${s.finish} · ${s.hex}">
          <span class="drop is-${s.finish} ${s.render_mode==="photo"?"is-photo":""}" style="--dot:${s.hex}"></span>
          <span class="cd">${s.code}</span></button>`).join("");
      $("bar").querySelectorAll("button").forEach(b=>b.onclick=()=>{
        state.shade=CATALOG.find(x=>x.slug===b.dataset.slug);sync();});
      $("count").textContent=`${list.length} of ${CATALOG.length} shades`;
    }
    function sync(){
      const s=state.shade;
      root.style.setProperty("--shade",s.hex);
      const [r,g,b]=hex2rgb(s.hex);
      root.style.setProperty("--shade-ink",(0.299*r+0.587*g+0.114*b)>150?"#171310":"#FFFFFF");

      const t=TONES.find(x=>x.key===state.tone),sh=SHAPES.find(x=>x.key===state.shape),
            ln=LENGTHS.find(x=>x.key===state.length);
      $("p-meta").textContent=`${t.label} · ${sh.label} · ${ln.label}`;
      $("p-name").textContent=shadeName(s);
      $("p-detail").textContent=`${s.code} · ${s.finish}`;
      $("p-hex").textContent=s.hex;

      $("b-name").textContent=shadeName(s);
      $("b-sub").textContent=`${s.product_title.slice(0,60)} · ${s.code}`;
      $("b-price").textContent=s.price?`$${Number(s.price).toFixed(2)}`:"—";
      $("b-unit").textContent=s.sku?`SKU ${s.sku}`:"";

      // Real Shopify endpoints, using variant ids pulled from the store's public
      // /products/{handle}.js. Two different routes on purpose:
      //   /cart/{id}:1        skips the cart and lands on checkout, where Shopify
      //                       renders the genuine Apple Pay / Shop Pay buttons
      //   /cart/add?id=..     adds to the cart and keeps the customer shopping
      const SHOP="https://nailcolorconsultation.com";
      const checkout=`${SHOP}/cart/${s.variant_id}:1`;
      const addToCart=`${SHOP}/cart/add?id=${s.variant_id}&quantity=1`;
      $("b-express").href=checkout;
      $("b-cart").href=addToCart;
    $("b-cart").onclick=ev=>{
      ev.preventDefault();
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({items:[{id:s.variant_id,quantity:1}]})})
        .then(r=>r.ok?r.json():Promise.reject(r))
        .then(()=>{ $("b-cart").textContent="Added to bag";
                    document.dispatchEvent(new CustomEvent("ncc:added"));
                    setTimeout(()=>{$("b-cart").textContent="Add to bag";},1800); })
        .catch(()=>{ window.location.href=addToCart; });
    };          // no-JS fallback; the click is intercepted
      if(!$("b-cart").dataset.wired){
        $("b-cart").dataset.wired="1";
        $("b-cart").addEventListener("click",ev=>{
          ev.preventDefault();
          addToBag(state.shade,$("b-cart"),"Add to bag");
        });
      }
      $("b-view").href=`${s.product_url}?variant=${s.variant_id}`;
      $("b-express").classList.toggle("hidden", !s.available);
      $("b-stock").innerHTML = s.available
        ? '<i></i> In stock · ships from the USA'
        : '<i style="background:#9A5B3B"></i> Currently unavailable';
      $("b-note").textContent=s.available
        ? "Express checkout opens Shopify checkout, where Apple Pay and Shop Pay appear on supported devices."
        : "This shade is currently unavailable.";

      $("tones").querySelectorAll("button").forEach(b=>b.setAttribute("aria-pressed",String(b.dataset.k===state.tone)));
      $("bar").querySelectorAll("button").forEach(b=>b.setAttribute("aria-pressed",String(b.dataset.slug===s.slug)));
      buildSteps();
      buildMatches();
      syncHero();
      render();
    }

    /* ---------------------------------------------------------------
       The hero strip — one lacquer on six hands.

       Same recolour maths as the main stage, run over a crop around the nails
       instead of the whole plate, so six of them cost less than one full render.
       The bounding box is measured once per plate from its own mask and cached.
       --------------------------------------------------------------- */
    // One frame shape for all six hands. 4:3 keeps the fingers in view on the
    // flat poses without cropping the curled ones too tightly.
    const HAND_AR=4/3;
    const bboxCache=new Map();
    function nailBox(maskImg,key){
      if(bboxCache.has(key))return bboxCache.get(key);
      const W=180,H=Math.round(180*maskImg.naturalHeight/maskImg.naturalWidth);
      const c=document.createElement("canvas");c.width=W;c.height=H;
      const x=c.getContext("2d",{willReadFrequently:true});
      x.drawImage(maskImg,0,0,W,H);
      const d=x.getImageData(0,0,W,H).data;
      let x0=W,y0=H,x1=0,y1=0,found=false;
      for(let p=0,i=0;p<W*H;p++,i+=4){
        if(d[i]<24)continue;
        const px=p%W,py=(p/W)|0;
        if(px<x0)x0=px; if(px>x1)x1=px; if(py<y0)y0=py; if(py>y1)y1=py; found=true;
      }
      const sx=maskImg.naturalWidth/W;
      const IW=maskImg.naturalWidth, IH=maskImg.naturalHeight;
      // A little air around the nails so the crop reads as a hand, not a specimen.
      const pad=0.34;
      let box;
      if(!found){ box={x:0,y:0,w:IW,h:IH}; }
      else{
        const bw=(x1-x0+1)*sx, bh=(y1-y0+1)*sx;
        const px2=bw*pad, py2=bh*pad;
        box={x:x0*sx-px2,y:y0*sx-py2,w:bw+px2*2,h:bh+py2*2};
      }
      // Force every crop to the same aspect ratio.
      //
      // Honey and tan are photographed as a curled fist while the other four are a
      // flat back-of-hand, so their nail bounding boxes are a different shape. Left
      // to follow its own box, each tile came out a different height and the row
      // read as ragged — tan worst of all. Grow the short side around the box
      // centre instead, so all six frames are identical and only the pose differs.
      const AR=HAND_AR;
      if(box.w/box.h < AR){ const w=box.h*AR; box.x-=(w-box.w)/2; box.w=w; }
      else { const h=box.w/AR; box.y-=(h-box.h)/2; box.h=h; }
      // If the widened box will not fit, shrink to the largest that does.
      if(box.w>IW){ const k=IW/box.w; box.w=IW; box.h*=k; }
      if(box.h>IH){ const k=IH/box.h; box.h=IH; box.w*=k; }
      box.x=Math.max(0,Math.min(box.x,IW-box.w));
      box.y=Math.max(0,Math.min(box.y,IH-box.h));
      bboxCache.set(key,box);return box;
    }

    async function paintHand(toneKey,cv){
      const key=`${toneKey}|${state.shape}|${state.length}`;
      let plate=PLATES.plates[key];
      if(!plate){ await PLATES_FULL; plate=PLATES.plates[key]; if(!plate)return; }
      const shade=state.shade;
      const [base,mask]=await Promise.all([loadImg(plate.src),loadImg(plate.mask)]);
      const box=nailBox(mask,key);
      const W=220,H=Math.round(W/HAND_AR);
      if(cv.width!==W||cv.height!==H){cv.width=W;cv.height=H;}
      const ctx=cv.getContext("2d",{willReadFrequently:true});
      ctx.drawImage(base,box.x,box.y,box.w,box.h,0,0,W,H);
      /* "photo" still bails -- those are the shades whose swatch we could not
         measure, and inventing a texture for them is the thing we refuse to do.
         "particle" is different: its flake geometry was measured off that shade's
         own product swatch, so it recolours to the measured BASE and the measured
         flake is composited on top below. */
      if(shade.render_mode!=="recolor"&&shade.render_mode!=="particle")return;
      const img=ctx.getImageData(0,0,W,H);
      const mc=document.createElement("canvas");mc.width=W;mc.height=H;
      const mx=mc.getContext("2d",{willReadFrequently:true});
      mx.drawImage(mask,box.x,box.y,box.w,box.h,0,0,W,H);
      const md=mx.getImageData(0,0,W,H).data;
      const [s05,s50,s92,s95,s998]=plate.srcL;
      const sLo=Math.max(s50-s05,1),sHi=Math.max(s95-s50,1);
      const [tr,tg,tb]=hex2rgb(shade.render_mode==="particle"
        ? (shade.base_hex||shade.hex) : shade.hex);
      const [tL,tA,tB]=rgb2lab(tr,tg,tb);
      const dLo=Math.max(tL*(1-PLATES.gloss.drop),2),dHi=Math.min(tL*(1+PLATES.gloss.lift),100);
      const dropSpan=Math.max(tL-dLo,1),liftSpan=Math.max(dHi-tL,1);
      const d=img.data;
      for(let i=0;i<d.length;i+=4){
        const m=md[i]/255; if(m<=0.004)continue;
        const [L]=rgb2lab(d[i],d[i+1],d[i+2]);
        const rel=L-s50;
        let outL=rel<0?tL+rel*(dropSpan/sLo):tL+rel*(liftSpan/sHi);
        const spec=Math.pow(Math.min(1,Math.max(0,(L-s92)/Math.max(s998-s92,1))),1.6);
        outL+=spec*Math.max(dHi-tL,0)*0.55;
        const damp=1-spec*0.72;
        const [nr,ng,nb]=lab2rgb(Math.min(100,Math.max(0,outL)),tA*damp,tB*damp);
        d[i]=d[i]*(1-m)+nr*m; d[i+1]=d[i+1]*(1-m)+ng*m; d[i+2]=d[i+2]*(1-m)+nb*m;
      }
      if(shade.render_mode==="particle")addParticles(d,md,W,H,shade,key);
      ctx.putImageData(img,0,0);
      levelGround(ctx,W,H,plateGround(plate));
      /* OFF. On the first run the safety gate refused porcelain, fair, honey and
         espresso and accepted only tan and deep -- two tinted tiles beside four
         cream ones is worse than six cream ones. Flip to true only once all six
         report tinted=1 in the harness. */
      /* OFF, and it should stay off until there is a real per-plate ALPHA MATTE.
         Tried twice, from both ends:
           - tight band (9.5 RGB): refused 4 of 6 tiles -> an inconsistent row
           - wide band (20 RGB):   accepted 4 of 6 and TORE porcelain and fair,
                                   leaving white holes and ragged finger edges
         Both failures are the same fact: pale skin on cream is not separable by
         colour distance, and connectivity does not save it because the fingers
         connect to the paper through pixels that are also within the band. No
         threshold exists that keeps porcelain intact and still moves its paper.
         The only reliable route is a proper hand matte per plate; a heuristic here
         will keep producing holes in hands. */
      const TINT_HANDS=false;
      const tinted=TINT_HANDS&&tintTileBackground(ctx,W,H,TONE_BG[toneKey]);
      const host=cv.parentElement;
      if(host){
        /* The card colour is a literal in the stylesheet now. Three rounds were
           lost setting it from here -- custom property, inline, then inline
           !important -- with the inline style verifiably present and the computed
           value still cream. A uniform colour has no reason to be set from JS at
           all, so it isn't. */
        host.dataset.tinted=tinted?"1":"0";
      }
    }

    /* Card matte, dark -> light across the six tones.
       ------------------------------------------------
       This is the SAFE version of the graded-ground idea. The first attempt shifted
       the photograph's own paper to these colours and tore the porcelain hand apart:
       background is found by connectivity at a tolerance tuned for nudging a colour,
       not replacing it, so every misclassified skin pixel became a hole. See the
       2026-08-17 work-log entry.

       Here the photograph stays on the page cream -- untouched, no segmentation
       involved, so no hand can be damaged -- and the CARD around it carries the
       graded colour. The row still reads dark to light; porcelain simply gets its
       contrast from a frame rather than from the inch behind the fingers. */
    /* ONE card colour for all six -- honey's value, Ray's pick. The graded card was
       tried and rejected: six different card colours made the row read as six
       mismatched panels, which is the complaint this whole thread is about. The
       grading now lives where he asked for it, behind the hand, not on the card. */
    const CARD="#D9CEBF";

    /* Ground behind the hand, per tone: dark for porcelain, light for espresso. */
    const TONE_BG={porcelain:[191,178,162], fair:[205,193,177], honey:[217,206,191],
                   tan:[228,218,204],       deep:[238,230,218], espresso:[246,240,231]};

    /* Repaint the paper behind the hand, in the tile, at draw time.
       -----------------------------------------------------------
       The earlier attempt did this in export_plates.py and tore the porcelain hand
       into fragments: it found background by colour distance at a tolerance tuned
       for nudging a value, and shifting 40 units turned every misclassified skin
       pixel into a hole.

       Two things make it safe here that were not true then:

       1. The plate's paper is now genuinely FLAT -- flatten_background() put it on
          the page cream within a few RGB -- so "close to cream" is a tight, honest
          test rather than a guess across a gradient.
       2. Selection is a FLOOD FILL from the tile border. Skin that happens to match
          cream is only caught if it is also connected to the edge through cream.

       And it refuses rather than risks: if the region found is not between 10% and
       92% of the tile, the tile is left on cream. A tile that keeps the old
       background is a cosmetic miss; a tile with holes in the hand is not
       shippable, and that asymmetry decides the default. */
    function tintTileBackground(ctx,W,H,rgb){
      if(!rgb)return false;
      const img=ctx.getImageData(0,0,W,H), d=img.data;
      const seen=new Uint8Array(W*H);
      /* Threshold measured from this tile's own border instead of assumed. A fixed
         9.5 RGB refused porcelain, fair, honey and espresso: their paper sits a few
         units off cream after levelGround, so a global constant cannot fit all six.
         Take the border's median colour as the paper reference and allow a band
         around it. */
      let br=0,bg2=0,bb=0,bn=0;
      for(let x=0;x<W;x+=2){for(const y of [0,H-1]){const i=(y*W+x)*4;
        br+=d[i];bg2+=d[i+1];bb+=d[i+2];bn++;}}
      for(let y=0;y<H;y+=2){for(const x of [0,W-1]){const i=(y*W+x)*4;
        br+=d[i];bg2+=d[i+1];bb+=d[i+2];bn++;}}
      const pr=br/bn, pg=bg2/bn, pb=bb/bn;
      const near=i=>{const dr=d[i*4]-pr,dg=d[i*4+1]-pg,db=d[i*4+2]-pb;
        return dr*dr+dg*dg+db*db < 400;};         // 20 RGB around the measured paper
      const stack=[];
      for(let x=0;x<W;x++){stack.push(x);stack.push((H-1)*W+x);}
      for(let y=0;y<H;y++){stack.push(y*W);stack.push(y*W+W-1);}
      let n=0;
      while(stack.length){
        const i=stack.pop();
        if(i<0||i>=W*H||seen[i])continue;
        if(!near(i)){seen[i]=2;continue;}
        seen[i]=1;n++;
        const x=i%W;
        if(x>0)stack.push(i-1);
        if(x<W-1)stack.push(i+1);
        if(i>=W)stack.push(i-W);
        if(i<W*(H-1))stack.push(i+W);
      }
      const frac=n/(W*H);
      if(frac<0.08||frac>0.95)return false;        // refuse rather than damage
      for(let i=0;i<W*H;i++){
        if(seen[i]!==1)continue;
        // shift, not replace: the paper's own shading survives the move
        d[i*4]  =Math.max(0,Math.min(255,d[i*4]  -pr+rgb[0]));
        d[i*4+1]=Math.max(0,Math.min(255,d[i*4+1]-pg+rgb[1]));
        d[i*4+2]=Math.max(0,Math.min(255,d[i*4+2]-pb+rgb[2]));
      }
      ctx.putImageData(img,0,0);
      return true;
    }

    /* plates.json carries `ground` as a hex; levelGround wants a triple. */
    function plateGround(plate){
      return plate&&plate.ground?hex2rgb(plate.ground):null;
    }

    /* Composite a measured flake onto the recoloured nail.
       -------------------------------------------------
       This is what lets the 148 glitter / shimmer / crackle shades appear on the
       hand at all. Nothing here is invented: `shade.particle` is measured by
       scripts/measure_particles.py off that shade's OWN product swatch -- flake
       density, flake diameter relative to nail size, how much brighter a flake is
       than the polish around it, and the flake's own colour. We supply the
       arithmetic; the polish supplies the numbers.

       Two properties matter more than realism:

       1. It is DETERMINISTIC, seeded on the shade code and the plate key. A shade
          must land its flake in the same places every render, or the sparkle
          crawls whenever the tone or length changes and the nail looks like it is
          boiling. Same shade + same plate = same flake, always.
       2. It never draws outside the nail mask, and it scales the flake by the
          nail's own size, so a short natural nail and a long stiletto get flake of
          the same physical size rather than the same pixel size. */
    /* The one place the flake's on-screen presence is tuned.
       ----------------------------------------------------
       Everything about a shade's flake -- how much of the nail it covers, how big
       it is, how bright, what colour -- is measured off that shade's own swatch.
       These three numbers are the only editorial input, and they exist because the
       swatch is a macro shot while the plate nail is ~150 px tall on screen: a
       faithful flake is sub-pixel there and averages into the polish (measured:
       local std 9.62 vs the same shade's crème at 14.25 — the sparkle made the nail
       SMOOTHER than no sparkle).

       `minRadius`  floor on flake size in pixels. The count is derived from the
                    radius, so raising this makes flakes bigger and proportionally
                    fewer -- the measured coverage is preserved, not inflated.
       `coverage`   the ONE honest departure: a straight multiplier on measured
                    density. Above 1 the nail carries more flake than the swatch
                    measured. Keep it modest and keep it here; do not scatter
                    fudge factors through the loop.
       `lift`       how hard the specular lift is driven, against measured boost.

       Raised 2026-08-16 on Ray's call: the first pass read correctly but too
       subtly at plate scale. */
    const FLAKE={minRadius:1.6, coverage:1.35, lift:1.25};

    function mulberry32(a){return function(){a|=0;a=a+0x6D2B79F5|0;
      let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;
      return((t^t>>>14)>>>0)/4294967296;};}

    function seedOf(str){let h=2166136261;
      for(let i=0;i<str.length;i++){h^=str.charCodeAt(i);h=Math.imul(h,16777619);}
      return h>>>0;}

    function addParticles(d,md,W,H,shade,key){
      const p=shade.particle; if(!p)return;

      // Nail pixels, collected once. Everything below indexes into this.
      const nail=[];
      for(let y=0;y<H;y++)for(let x=0;x<W;x++){
        const i=(y*W+x)*4; if(md[i]>128)nail.push(i);
      }
      const area=nail.length; if(area<24)return;

      /* MINIMUM LEGIBLE SIZE. The measured flake is physically tiny relative to the
         nail: size_frac ~0.0066 against a plate nail of ~21,000 px is a radius of
         about half a pixel. Drawn faithfully at that size with a soft edge it
         averages straight back into the polish -- measured on the first build, the
         glitter's local std came out at 9.62 against the same shade's crème at
         14.25, i.e. the sparkle made the nail SMOOTHER than no sparkle at all.

         So the flake is floored at a radius the screen can actually resolve, and
         the COUNT is derived from that radius, which keeps the measured coverage
         (density) intact -- bigger flake, proportionally fewer of them. The polish
         still decides how much of the nail is flake; only the pixel size is ours. */
      const scale=Math.sqrt(area);
      const rad=Math.max(FLAKE.minRadius,(p.size*scale)/2);
      const flakeArea=Math.max(Math.PI*rad*rad,1);
      const count=Math.min(Math.round(area*p.density*FLAKE.coverage/flakeArea),6000);
      if(count<1)return;

      const [pr,pg,pb]=hex2rgb(p.hex);
      /* A flake is a specular event: it catches light and throws it back white-ish.
         Multiplying its own colour by a gain cannot brighten a dark flake on a dark
         polish, which is why an espresso glitter stayed invisible. Add the boost as
         an explicit achromatic lift instead -- that is what makes it read as a
         sparkle rather than as a slightly different shade of the same colour. */
      const lift=Math.max(p.boost,0)/100*255*FLAKE.lift;
      const rnd=mulberry32(seedOf((shade.code||"")+"|"+key));
      const R=Math.ceil(rad);
      const core=rad*0.55, feather=Math.max(rad-core,0.35);

      for(let n=0;n<count;n++){
        const c=nail[(rnd()*area)|0];
        const ci=c/4, cx=ci%W, cy=(ci/W)|0;
        // Vary each flake so the field does not read as a regular printed screen.
        const jitter=0.85+rnd()*0.4;   // tighter than before: fewer half-strength flakes
        for(let dy=-R;dy<=R;dy++)for(let dx=-R;dx<=R;dx++){
          const x=cx+dx, y=cy+dy; if(x<0||y<0||x>=W||y>=H)continue;
          const dist=Math.sqrt(dx*dx+dy*dy); if(dist>rad)continue;
          const i=(y*W+x)*4;
          const m=md[i]/255; if(m<=0.004)continue;   // never spill off the nail
          // Flat core with a short feather. An all-feather flake is what washed out.
          const a=Math.min(1,dist<=core?1:1-(dist-core)/feather)*jitter*m;
          if(a<=0.01)continue;
          const t=a*0.85, l=a*lift;
          d[i]  =Math.min(255,d[i]  *(1-t)+pr*t+l);
          d[i+1]=Math.min(255,d[i+1]*(1-t)+pg*t+l);
          d[i+2]=Math.min(255,d[i+2]*(1-t)+pb*t+l);
        }
      }
    }

    /* Put every hero tile on porcelain's ground.
       ------------------------------------------
       The plates are white-balanced, so their frames agree to within 3 RGB — but
       the hero crops in tight, and inside that crop honey carries a light grey
       surface and deep a peach one while the rest sit near porcelain's ground.
       Six tiles side by side made that read as six different studios.

       This measures each tile's own ground and shifts the WHOLE tile by the
       difference — a uniform correction, the same thing a colourist does to match
       two frames.

       It deliberately does NOT decide per pixel what is ground and what is hand.
       The first version did, gating on "bright and near-neutral", and erased
       porcelain's hand: pale skin is bright and near-neutral too, so the fingers
       were blended into the background and the tile came back as floating nails.
       There is no colour test that separates porcelain skin from cream paper, and
       the segmentation attempts in the work log all failed for the same reason.

       TWO BUGS FIXED 2026-08-16, both of which made the tiles miss the page:

       1. GROUND was [229,221,209] — a measured plate value, not the page. The page
          paints --paper #E6DED4 = [230,222,212] and export_plates.py white-balances
          every plate to that same STAGE, so the target here MUST be that value or
          each tile is levelled onto a cream the page never paints. It was off by
          1/1/3 on all six, permanently. Keep this constant equal to --paper.

       2. The sample was the top 3 rows across the full width. These crops are grown
          around the NAIL box, so the top edge is exactly where fingertips sit — the
          median landed on skin, and the clamp then capped the damage instead of
          correcting it. Now it reads four corner patches and takes the median of
          their four medians, which survives one or two corners catching the hand.

       The shift is still clamped so that if every corner somehow lands on skin the
       worst case is a tile a shade off, not a ruined photograph. */
    /* Was a single page-cream constant. With per-tone grounds the target has to
       come from the plate itself, or this function would helpfully undo the
       grading it knows nothing about. plates.json carries `ground` per plate so
       there is exactly one source of truth for it. */
    const GROUND=[230,222,212];       // fallback only: a plate with no `ground`
    function levelGround(ctx,W,H,ground){
      const med=a=>{a.sort((x,y)=>x-y);return a[a.length>>1];};
      const P=Math.max(6,Math.round(Math.min(W,H)*0.08));
      const corners=[[0,0],[W-P,0],[0,H-P],[W-P,H-P]].map(([x,y])=>{
        const d=ctx.getImageData(x,y,P,P).data,rs=[],gs=[],bs=[];
        for(let i=0;i<d.length;i+=4){rs.push(d[i]);gs.push(d[i+1]);bs.push(d[i+2]);}
        return [med(rs),med(gs),med(bs)];
      });
      /* median of the four corner medians: one bad corner cannot move it, and two
         only move it halfway. A plain mean would let a single fingertip drag it. */
      const mid=c=>{const v=corners.map(p=>p[c]).sort((a,b)=>a-b);return (v[1]+v[2])/2;};
      const clamp=v=>Math.max(-10,Math.min(10,Math.round(v)));
      const G=ground||GROUND;
      const dr=clamp(G[0]-mid(0)), dg=clamp(G[1]-mid(1)), db=clamp(G[2]-mid(2));
      if(!dr&&!dg&&!db)return;
      const img=ctx.getImageData(0,0,W,H), d=img.data;
      for(let i=0;i<d.length;i+=4){
        d[i]=Math.max(0,Math.min(255,d[i]+dr));
        d[i+1]=Math.max(0,Math.min(255,d[i+1]+dg));
        d[i+2]=Math.max(0,Math.min(255,d[i+2]+db));
      }
      ctx.putImageData(img,0,0);
    }

    function buildHero(){
      const host=$("hands"); if(!host)return;          // only the homepage has it
      host.innerHTML=TONES.map(t=>`<button type="button" data-k="${t.key}"
          aria-pressed="${state.tone===t.key}" title="See the tool on the ${t.label.toLowerCase()} hand">
          <canvas width="220" height="150"></canvas><span class="cap">${t.label}</span></button>`).join("");
      host.querySelectorAll("button").forEach(b=>b.onclick=()=>{
        state.tone=b.dataset.k; sync();
        $("workspace").scrollIntoView({behavior:"smooth",block:"start"});
      });
      requestAnimationFrame(()=>host.classList.add("is-in"));
      syncHero();
    }

    function syncHero(){
      const host=$("hands"); if(!host)return;
      const s=state.shade, live=s.render_mode!=="photo";
      $("h-name").textContent=shadeName(s);
      $("h-meta").textContent=`${s.code} · ${s.hex}`;
      $("h-note").textContent=live
        ? "The same bottle, photographed on six hands. Pick one to try it on yourself."
        : `${s.finish[0].toUpperCase()+s.finish.slice(1)} can't be painted onto the hand — its particles aren't in the photograph. Pick a crème to see it here.`;
      host.classList.toggle("hidden",!live);
      if(!live)return;
      host.querySelectorAll("button").forEach(b=>{
        b.setAttribute("aria-pressed",String(b.dataset.k===state.tone));
        paintHand(b.dataset.k,b.querySelector("canvas"));
      });
    }

    /* ---------------------------------------------------------------
       Step rail, best matches, and the copy in the closing bands.

       Everything numeric below is measured, not written. SKIN_LAB is the median
       CIE Lab of each tone's own photograph, sampled outside the nail mask —
       the same values design/tone-skin-lab.json carries and the landing-page
       copy is generated from. Distance is plain dE76 between a shade and that
       skin, which is what "reads as contrast against your hand" actually means.
       --------------------------------------------------------------- */
    const SKIN_LAB={porcelain:[76.8,3.6,9.5],fair:[73.7,7.5,22.2],honey:[73.7,6.0,23.6],
                    tan:[56.7,15.3,23.1],deep:[40.4,11.6,17.3],espresso:[22.6,9.1,11.7]};
    function skinDist(hex,toneKey){
      const [r,g,b]=hex2rgb(hex), L=rgb2lab(r,g,b), s=SKIN_LAB[toneKey]||SKIN_LAB.tan;
      return Math.hypot(L[0]-s[0],L[1]-s[1],L[2]-s[2]);
    }
    /* A distance, said in words. Deliberately not a "match %": we have no model
       of what a shopper wants, so a percentage would be a number with nothing
       behind it. The exact figure is on the title attribute for anyone curious. */
    function contrastWord(d){ return d>=55?"High contrast":d>=32?"Medium":"Blends in"; }

    function buildSteps(){
      const t=TONES.find(x=>x.key===state.tone),sh=SHAPES.find(x=>x.key===state.shape),
            ln=LENGTHS.find(x=>x.key===state.length);
      const rows=[["01","Tone",t.label],["02","Shape",sh.label],
                  ["03","Length",ln.label],["04","Color",shadeName(state.shade)]];
      $("steps").innerHTML=rows.map(([n,k,v],i)=>
        `<li data-live="${i===3}"><span class="n">${n}</span><span class="k">${k}</span>
          <span class="v">${v}</span></li>`).join("");
    }

    function bottleSvg(hex){
      return `<svg viewBox="0 0 46 86" aria-hidden="true">
        <rect x="17" y="2" width="12" height="17" rx="1" fill="var(--ink)"/>
        <rect x="20" y="19" width="6" height="6" fill="var(--ink)" opacity=".5"/>
        <path d="M9 34c0-5 3-8 8-9h12c5 1 8 4 8 9v42a6 6 0 0 1-6 6H15a6 6 0 0 1-6-6z"
              fill="${hex}" stroke="rgba(23,19,16,.28)" stroke-width="1"/>
        <path d="M13 40c1-3 4-4 6-4" stroke="rgba(255,255,255,.5)" stroke-width="2.5"
              stroke-linecap="round" fill="none"/></svg>`;
    }

    function buildMatches(){
      const tone=TONES.find(x=>x.key===state.tone);
      $("m-tone").textContent=tone.label.toLowerCase();
      const pool=visible().filter(s=>s.render_mode==="recolor" && s.available);
      const ranked=pool.map(s=>({s,d:skinDist(s.hex,state.tone)})).sort((a,b)=>b.d-a.d).slice(0,5);
      $("m-note").textContent=ranked.length
        ? `The ${ranked.length} of ${pool.length} paintable shades in view that sit furthest `
          + `from the skin in the ${tone.label.toLowerCase()} photograph. Every one renders on the hand above.`
        : "No paintable shades in the current filter — clear it to see the full range.";
      $("m-grid").innerHTML=ranked.map(({s,d})=>`
        <article class="mcard">
          <div class="art">${bottleSvg(s.hex)}</div>
          <div class="stripe" style="--dot:${s.hex}"></div>
          <div class="body">
            <span class="contrast" title="ΔE ${d.toFixed(0)} from this tone's measured skin colour">${contrastWord(d)}</span>
            <h3>${shadeName(s)}</h3>
            <p class="meta"><span>${s.code}</span><span>${s.finish}</span></p>
            <div class="foot">
              <span class="p">$${Number(s.price).toFixed(2)}</span>
              <button type="button" data-slug="${s.slug}">Add</button>
            </div>
          </div>
        </article>`).join("");
      $("m-grid").querySelectorAll("button").forEach(b=>b.onclick=()=>{
        state.shade=CATALOG.find(x=>x.slug===b.dataset.slug); sync();
        addToBag(state.shade,b,"Add");
      });
    }

    /* Add to the cart without leaving the page.
       ----------------------------------------
       What this replaces: `#b-cart` was an <a target="_blank"> pointing at
       /cart/add, and the match cards called .click() on it. So every Add opened a
       NEW TAB, navigated it to /cart, and left the page the shopper was actually
       looking at showing a stale cart count — or did nothing at all when a popup
       blocker ate it. The item did arrive in the cart, which is why it never looked
       broken from the server side.

       Now: POST /cart/add.js, then repaint the theme's own cart bubble from
       Shopify's Section Rendering API so the header count is true immediately.
       The <a href> is kept as the no-JS fallback and still works if this throws. */
    async function addToBag(shade,btn,restLabel){
      if(!shade||btn.dataset.busy)return;
      const rest=restLabel||btn.textContent;
      btn.dataset.busy="1"; btn.setAttribute("aria-busy","true"); btn.textContent="Adding…";
      try{
        const r=await fetch("/cart/add.js",{method:"POST",credentials:"same-origin",
          headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify({items:[{id:shade.variant_id,quantity:1}]})});
        if(!r.ok)throw new Error("add failed "+r.status);
        btn.textContent="Added ✓";
        refreshCartCount();
      }catch(e){
        /* Say so rather than silently reverting — a shopper who is told nothing
           clicks again and buys two. */
        btn.textContent="Try again";
      }finally{
        setTimeout(()=>{btn.textContent=rest;btn.removeAttribute("aria-busy");
          delete btn.dataset.busy;},2000);
      }
    }

    /* Repaint the host theme's cart bubble. Section Rendering returns the section's
       own markup, so the count, the bubble's presence when the cart was empty, and
       the theme's own styling all come back correct without us guessing at it.

       The id to read is `shopify-section-cart-icon-bubble`, NOT `cart-icon-bubble`.
       Section Rendering returns the section wrapper; `cart-icon-bubble` is the id of
       the <a> in the theme's header, which lives OUTSIDE the section and therefore
       never appears in the response. Reading the wrong one returns null, and because
       the code then did nothing, the bubble silently kept its old count — the exact
       failure this function exists to fix. */
    async function refreshCartCount(){
      const host=document.getElementById("cart-icon-bubble"); if(!host)return;
      try{
        const res=await fetch("/?sections=cart-icon-bubble",{credentials:"same-origin"});
        const html=(await res.json())["cart-icon-bubble"];
        const doc=new DOMParser().parseFromString(html,"text/html");
        const fresh=doc.getElementById("shopify-section-cart-icon-bubble")
                 || doc.getElementById("cart-icon-bubble");
        if(fresh)host.innerHTML=fresh.innerHTML;
      }catch(e){/* the count corrects itself on the next page load */}
    }

    /* Band copy, counted from the catalogue that is actually loaded so the
       claims cannot drift away from the data the way the landing pages once did. */
    (function bandCopy(){
      const live=CATALOG.filter(s=>s.render_mode!=="photo").length;
      const p1=$("p-1"), p2=$("p-2"), p3=$("p-3"), c=$("c-note");
      if(p1) p1.textContent=`Six skin tones, three nail shapes and three lengths — `
        + `54 separate photographs of a real hand. Changing your tone loads a different `
        + `photograph, not a filter over the same one.`;
      if(p2) p2.textContent=`Every shade's colour was measured off its own product `
        + `photograph rather than typed in, which is how ${live} of ${CATALOG.length} `
        + `can be painted onto the hand at all.`;
      if(p3) p3.textContent=`Each colour here is tied to a live variant with its own `
        + `price and stock. Nothing in the bar is a mock-up you cannot buy.`;
      if(c) c.textContent=`A lacquer reads differently on every hand it touches. `
        + `See it on skin like yours, on the nail shape you actually wear, before you spend anything.`;
    })();

    /* ---------------------------------------------------------------
       Color Guide. Four questions, scored against the real catalogue.

       The mode button existed in the markup before this but did nothing —
       a dead control is worse than no control. Recommendations are limited
       to recolourable shades so the result can actually be shown on the
       hand, which is the whole point of handing back to the try-on.
       --------------------------------------------------------------- */
    const QS=[
     {k:"occasion",cap:"Occasion",q:"What are you dressing for?",a:[
       {v:"wedding",n:"A wedding",d:"guest or bridal"},
       {v:"work",n:"Work",d:"office or an interview"},
       {v:"date",n:"Date night",d:"dinner or an evening out"},
       {v:"vacation",n:"Vacation",d:"resort or a getaway"},
       {v:"party",n:"A celebration",d:"party or a milestone"},
       {v:"everyday",n:"Everyday",d:"polished daily color"}]},
     {k:"season",cap:"Season",q:"What season is it where you are?",a:[
       {v:"spring",n:"Spring"},{v:"summer",n:"Summer"},{v:"fall",n:"Autumn"},{v:"winter",n:"Winter"}]},
     {k:"outfit",cap:"Outfit",q:"What color anchors the outfit?",a:[
       {v:"black",n:"Black",sw:"#26231F"},{v:"white",n:"White or cream",sw:"#E4DCCE"},
       {v:"blue",n:"Blue",sw:"#6682A5"},{v:"green",n:"Green",sw:"#728773"},
       {v:"red",n:"Red or pink",sw:"#A85454"},{v:"neutral",n:"Neutral or metallic",sw:"#B9A18B"}]},
     {k:"usual",cap:"Your palette",q:"What do you usually wear?",a:[
       {v:"soft",n:"Soft neutrals",d:"sheer pinks and nudes",sw:"#E8CFCB"},
       {v:"warm",n:"Warm color",d:"corals and classic reds",sw:"#CD6659"},
       {v:"dark",n:"Deep color",d:"berries, wines and plum",sw:"#4B2935"}]}
    ];
    /* family preference + target depth (0 = pale, 1 = darkest) per answer */
    const SCORE={
     occasion:{wedding:[["nude","pink"],.72],work:[["nude","plum"],.6],date:[["red","plum"],.3],
       vacation:[["orange","pink"],.55],party:[["red","purple"],.35],everyday:[["nude","pink"],.65]},
     season:{spring:[["pink","green"],.62],summer:[["orange","red"],.55],
       fall:[["plum","orange"],.32],winter:[["plum","red"],.28]},
     outfit:{black:[["red","plum"],.3],white:[["orange","red"],.5],blue:[["nude","pink"],.55],
       green:[["orange","nude"],.5],red:[["nude","pink"],.6],neutral:[["plum","red"],.4]},
     usual:{soft:[["nude","pink"],.75],warm:[["orange","red"],.5],dark:[["plum","purple"],.25]}
    };
    const gstate={step:0,ans:{},friend:null};

    function lumOf(hex){const h=hex.replace("#","");
      return (0.299*parseInt(h.slice(0,2),16)+0.587*parseInt(h.slice(2,4),16)+0.114*parseInt(h.slice(4,6),16))/255;}

    /* ---- the best friend suggestion ----------------------------------------
       `recommend()` gives you the shade you already know you like. This gives you
       the one a friend would put in your hand — deliberately outside the palette
       you told us you live in, but only if it still works with what you're wearing.
       That second condition is the whole point: "be braver" is not advice, "this
       pink works against the black you're already in" is.

       The comfort zone is BOTH families behind your "what you usually wear"
       answer, plus whatever the safe match landed on. Excluding only the primary
       one let it offer a red to someone who had just said they live in "warm reds
       and corals" — technically a different family, obviously not a suggestion. */
    const USUAL_WORD={soft:"soft neutrals",warm:"warm reds and corals",dark:"deep berries and plums"};
    const OUTFIT_WORD={black:"black",white:"white or cream",blue:"blue",green:"green",
                       red:"red or pink",neutral:"a neutral or metallic"};
    const FAMILY_WORD={red:"red",pink:"pink",plum:"plum",purple:"violet",blue:"blue",green:"green",
                       orange:"coral",nude:"nude",yellow:"citrine",neutral:"grey",black:"black"};

    function bestFriend(safe){
      const usual=gstate.ans.usual, outfit=gstate.ans.outfit;
      const comfort=new Set();
      if(usual) SCORE.usual[usual][0].forEach(f=>comfort.add(f));
      if(safe) comfort.add(safe.family);
      const outfitFams=outfit?SCORE.outfit[outfit][0]:[];

      // `useOutfit` has to switch off in the fallback pass as well as the filter.
      // Leaving the outfit bonus in the scoring made the "braver" pass re-rank to
      // exactly the same shade, so the fallback never fired and the nude survived.
      const pick=(useOutfit)=>{
        const out=[];
        CATALOG.forEach(s=>{
          if(s.render_mode!=="recolor"||!s.available)return;
          if(comfort.has(s.family))return;                 // must leave the comfort zone
          const oi=useOutfit?outfitFams.indexOf(s.family):-1;
          if(useOutfit && oi<0)return;                     // must still go with the outfit
          const [r,g,b]=hex2rgb(s.hex),mx=Math.max(r,g,b),mn=Math.min(r,g,b);
          const sat=mx?(mx-mn)/mx:0;                       // a stretch needs conviction
          const away=safe?Math.abs(lumOf(s.hex)-lumOf(safe.hex)):0;
          // Chroma is weighted hard and washed-out shades are penalised outright.
          // Without this the pick drifts to whatever merely sits outside the stated
          // palette — it once offered a nude to someone who wears corals, which is
          // not a suggestion, it is a shrug.
          const score=(oi===0?4:oi===1?3:0)+sat*5+away+(sat<0.22?-4:0);
          out.push({s,score});
        });
        // One shade per family, then the four strongest families. Taking the top
        // four shades outright returned four near-identical plums, which is not
        // rotation, it is the same suggestion four times.
        const byFam={};
        out.forEach(c=>{if(!byFam[c.s.family]||c.score>byFam[c.s.family].score)byFam[c.s.family]=c;});
        return Object.values(byFam).sort((a,b)=>b.score-a.score).slice(0,4).map(c=>c.s);
      };
      // How far the suggestion actually sits from the shade they were going to
      // buy anyway. Saturation was the wrong test -- nudes sit around 0.30 and
      // sailed through, so someone who wears corals was offered a nude and told it
      // was a stretch. Perceptual distance is the honest measure of "outside your
      // comfort zone", and 40 dE is roughly where a shade stops being a neighbour.
      const gap=s=>(!s||!safe)?0:(()=>{const a=rgb2lab(...hex2rgb(s.hex)),
        b=rgb2lab(...hex2rgb(safe.hex));
        return Math.hypot(a[0]-b[0],a[1]-b[1],a[2]-b[2]);})();
      // Prefer a pick that also goes with the outfit -- that is what makes this
      // advice rather than a dare -- but not at the cost of it being a real move.
      const roll=list=>list[Math.floor(Math.random()*list.length)];
      const withOutfit=pick(true), anywhere=pick(false);
      // Rotate only among candidates that clear the distance bar. A friend varies
      // what they say; they do not start saying something limp.
      const strong=withOutfit.filter(s=>gap(s)>=40);
      if(strong.length) return {shade:roll(strong),matchedOutfit:true};
      const bolder=anywhere.filter(s=>gap(s)>gap(withOutfit[0])+10);
      if(bolder.length) return {shade:roll(bolder),matchedOutfit:false};
      return {shade:withOutfit[0]||anywhere[0], matchedOutfit:!!withOutfit.length};
    }

    function friendReason(f,safe){
      const usual=gstate.ans.usual, outfit=gstate.ans.outfit;
      const fam=FAMILY_WORD[f.shade.family]||f.shade.family;
      const you=USUAL_WORD[usual]||"what you usually reach for";
      if(f.matchedOutfit && outfit){
        // "Against red or pink, a pink still works" is technically true and reads
        // like a shrug. When the shade sits inside the outfit's own colour, say
        // what is actually happening: it is a tonal move, not a contrast one.
        if(OUTFIT_WORD[outfit].includes(fam))
          return `You said you live in ${you}. This picks up the ${OUTFIT_WORD[outfit]} `
               + `you're already wearing instead of fighting it — tonal, not matchy.`;
        return `You said you live in ${you}. Against ${OUTFIT_WORD[outfit]}, a ${fam} `
             + `still works — it reads as a decision rather than an accident.`;
      }
      return `You said you live in ${you}. This is the ${fam} to try when you want `
           + `the manicure to be the thing people notice.`;
    }

    function recommend(){
      const fam={};let depth=0,n=0;
      QS.forEach(q=>{const v=gstate.ans[q.k];if(!v)return;
        const [fams,d]=SCORE[q.k][v];fams.forEach((f,i)=>fam[f]=(fam[f]||0)+(i===0?2:1));
        depth+=d;n++;});
      if(!n)return null;
      const target=1-(depth/n);           // convert "depth" to target luminance
      let best=null,bestScore=-1e9;
      CATALOG.forEach(s=>{
        if(s.render_mode!=="recolor"||!s.available)return;
        const fs=(fam[s.family]||0);
        const score=fs*3 - Math.abs(lumOf(s.hex)-target)*6;
        if(score>bestScore){bestScore=score;best=s;}
      });
      return best;
    }

    function renderGuide(){
      const rail=$("g-rail"),body=$("g-body");
      rail.innerHTML=QS.map((q,i)=>{
        const st=gstate.ans[q.k]?"done":(i===gstate.step?"active":"todo");
        return `<span class="step" data-state="${st}"><span class="dot"></span><span class="cap">${q.cap}</span></span><span class="link"></span>`;
      }).join("")+`<span class="step" data-state="${gstate.step>=QS.length?"done":"todo"}"><span class="dot"></span><span class="cap">Your color</span></span>`;

      if(gstate.step>=QS.length){
        const s=recommend();
        if(!s){gstate.step=0;return renderGuide();}
        // Roll once per completed flow, not per render — otherwise any re-render
        // of the same result reshuffles the suggestion under the shopper. Start
        // over clears it, so running the consultation again can land elsewhere.
        if(!gstate.friend) gstate.friend=bestFriend(s);
        const f=gstate.friend;
        body.innerHTML=`<div class="guide-res">
          <span class="bigdrop" style="--dot:${s.hex}"></span>
          <div>
            <p class="eyebrow">Your match</p>
            <h2>${shadeName(s)}</h2>
            <p>${s.product_title} · ${s.code} · $${s.price}</p>
            <div class="guide-nav" style="border:0;padding:0">
              <button class="btn btn--buy" id="g-see">See it on my skin</button>
              <button class="btn" id="g-again">Start over</button>
            </div>
          </div></div>
          ${f.shade?`<div class="friend">
            <span class="fdrop" style="--dot:${f.shade.hex}"></span>
            <div class="fbody">
              <p class="eyebrow">Best <span class="script">friend</span> suggestion</p>
              <h3>${shadeName(f.shade)}</h3>
              <p class="why">${friendReason(f,s)}</p>
              <p class="fmeta">${f.shade.code} · $${f.shade.price}</p>
            </div>
            <button class="btn" id="g-friend">Try this one instead</button>
          </div>`:""}`;
        $("g-see").onclick=()=>{state.shade=s;state.family="all";buildBar();sync();showMode("try");};
        $("g-again").onclick=()=>{gstate.step=0;gstate.ans={};gstate.friend=null;renderGuide();};
        if(f.shade) $("g-friend").onclick=()=>{
          state.shade=f.shade;state.family="all";buildBar();sync();showMode("try");};
        return;
      }
      const q=QS[gstate.step];
      body.innerHTML=`<div class="guide-q">
        <p class="eyebrow">Question ${gstate.step+1} of ${QS.length}</p>
        <h2>${q.q}</h2>
        <div class="guide-a">${q.a.map(o=>`
          <button type="button" data-v="${o.v}">
            ${o.sw?`<span class="sw" style="--gsw:${o.sw}"></span>`:""}
            <span class="an">${o.n}</span>${o.d?`<span class="ad">${o.d}</span>`:""}
          </button>`).join("")}</div>
        <div class="guide-nav">
          <button class="btn" id="g-back" ${gstate.step===0?"disabled":""}>Back</button>
      
        </div></div>`;
      body.querySelectorAll(".guide-a button").forEach(b=>b.onclick=()=>{
        gstate.ans[q.k]=b.dataset.v;gstate.step++;renderGuide();});
      $("g-back").onclick=()=>{gstate.step=Math.max(0,gstate.step-1);renderGuide();};
    }

    function showMode(m){
      const onTry=m==="try";
      $("workspace").classList.toggle("hidden",!onTry);
      $("guide").classList.toggle("hidden",onTry);
      $("m-try").setAttribute("aria-pressed",String(onTry));
      $("m-guide").setAttribute("aria-pressed",String(!onTry));
      if(!onTry)renderGuide();
    }
    $("m-try").onclick=()=>showMode("try");
    $("m-guide").onclick=()=>showMode("guide");

    /* The closing band's CTA opens the consultation rather than sending the
       shopper to another page to look for it. The four-question flow IS the
       consultation the store is named after, so the link is intercepted here and
       the mode switched in place; the href stays real so it still works with JS
       off and a crawler can follow it. #consultation on any page opens it too. */
    const startCta=$("c-start");
    if(startCta) startCta.onclick=ev=>{
      ev.preventDefault();
      showMode("guide");
      $("guide").scrollIntoView({behavior:"smooth",block:"start"});
      if(history.replaceState) history.replaceState(null,"","#consultation");
    };
    if(location.hash==="#consultation"){
      showMode("guide");
      requestAnimationFrame(()=>$("guide").scrollIntoView({block:"start"}));
    }

    buildTones();buildSeg("shapes",SHAPES,"shape",true);buildSeg("lengths",LENGTHS,"length",false);
    buildHero();
    buildFilters();buildBar();sync();

    /* Reveal each major band once as it arrives. One observer, unobserved after
       firing, so nothing keeps running while the shopper works. Sections already
       on screen at load are shown immediately rather than animated in — a reveal
       that plays on something you are already looking at is just a flicker. */
    function armReveals(){
      const targets=[...root.querySelectorAll(".matches,.band,.contact,.contact-more")];
      if(!targets.length)return;
      const reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
      if(reduce||!("IntersectionObserver" in window)){targets.forEach(t=>t.classList.add("is-vis"));return;}
      targets.forEach(t=>{
        const r=t.getBoundingClientRect();
        if(r.top<innerHeight*0.9){t.classList.add("reveal","is-vis");}
        else t.classList.add("reveal");
      });
      const io=new IntersectionObserver((es)=>{
        es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add("is-vis"); io.unobserve(e.target); } });
      },{rootMargin:"0px 0px -10% 0px",threshold:0.05});
      targets.forEach(t=>{ if(!t.classList.contains("is-vis")) io.observe(t); });
    }
    armReveals();

    const tc=$("tb-count"); if(tc) tc.textContent=CATALOG.length;
  }
})();
